import axios from "axios"
import { baseUrlApi } from "./Api.js"
import Csrf from "./Csrf.js"

export default {

  postLogin(credentials) {
    const url = `${baseUrlApi}/login`;
    return axios.post(url, credentials);
  },

  postLogout() {
    const url = `${baseUrlApi}/logout`;
    return axios.post(url);
  },

  getIndex() {
    const url = `${baseUrlApi}/get-users`;
    return axios.get(url);
  },

  postUser(userId) {
    const url = `${baseUrlApi}/post-user/${userId}`;
    return axios.post(url);
  },

  getRoles() {
    const url = `${baseUrlApi}/get-roles`;
    return axios.get(url);
  },

  postCreateUser(form) {
    const url = `${baseUrlApi}/create-user`;
    return axios.post(url, form);
  },

  putUpdateUser(form) {
    const url = `${baseUrlApi}/update-user`;
    return axios.put(url, form);
  },
};

